import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
const heroFollowRequirementMock = "https://d1vqw4it8x9uac.cloudfront.net/admin/iphone-14-3-1790236892.png";
const heroFollowStepLocation = "https://d1vqw4it8x9uac.cloudfront.net/admin/hero-follow-step-location-1790236892.png";
const heroFollowStepBudget = "https://d1vqw4it8x9uac.cloudfront.net/admin/hero-follow-step-budget-1790236892.png";
const heroFollowStepSuccess = "https://d1vqw4it8x9uac.cloudfront.net/admin/hero-follow-step-success-1790236892.png";

const listMotion = {
  hidden: { opacity: 0, y: 26 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
      ease: "easeOut",
      staggerChildren: 0.12,
      delayChildren: 0.08,
    },
  },
};

const itemMotion = {
  hidden: { opacity: 0, y: 22 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

/**
 * Second band below the hero — same shell as RevampHero, with handset mock on the left (hero keeps phone on the right).
 */
function RevampHeroFollow() {
  const [followDecorReady, setFollowDecorReady] = useState(false);
  const stageRef = useRef(null);

  useEffect(() => {
    const stage = stageRef.current;
    if (!stage) return undefined;

    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;
    if (prefersReducedMotion) {
      setFollowDecorReady(true);
      return undefined;
    }

    if (typeof IntersectionObserver === "undefined") {
      setFollowDecorReady(true);
      return undefined;
    }

    const isPhone = window.matchMedia("(max-width: 760px)").matches;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setFollowDecorReady(true);
            observer.unobserve(entry.target);
          }
        });
      },
      isPhone
        ? {
            // Phone: fire as soon as the stage starts entering view
            // so the cards aren't blank while the user is mid-scroll.
            rootMargin: "0px 0px -2% 0px",
            threshold: 0.01,
          }
        : {
            rootMargin: "-8% 0px -18%",
            threshold: 0.24,
          }
    );

    observer.observe(stage);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="revamp-hero-wrap revamp-hero-follow-wrap">
      <section className="revamp-hero revamp-hero-follow" aria-label="Post your requirement">
        <div className="revamp-hero-inner">
          <div className="revamp-hero-split revamp-hero-follow-split">
            <div className="revamp-hero-follow-media" aria-hidden="true">
              <div
                ref={stageRef}
                className={`revamp-hero-follow-stage ${followDecorReady ? "is-ready" : ""}`}
              >
                <img className="revamp-hero-follow-phone" src={heroFollowRequirementMock} alt="" />
                {/* <div className="revamp-hero-follow-steps">
                  <div className="revamp-hero-follow-step-wrap is-left is-top" style={{ "--d": "0ms" }}>
                    <img className="revamp-hero-follow-step" src={heroFollowStepLocation} alt="" />
                  </div>
                  <div className="revamp-hero-follow-step-wrap is-right is-mid" style={{ "--d": "110ms" }}>
                    <img className="revamp-hero-follow-step" src={heroFollowStepBudget} alt="" />
                  </div>
                  <div className="revamp-hero-follow-step-wrap is-left is-last is-bottom" style={{ "--d": "220ms" }}>
                    <img className="revamp-hero-follow-step" src={heroFollowStepSuccess} alt="" />
                  </div>
                </div> */}
              </div>
            </div>
            <div className="revamp-hero-left revamp-hero-follow-copy">
              <div className="revamp-hiw-kicker">
                <span className="revamp-hiw-dash" aria-hidden="true" />
                <span className="revamp-hiw-kicker-text">How It Works</span>
              </div>

              <h2 className="revamp-hiw-title">
                Finding professionals,
                <br />
                <span className="revamp-hiw-title-accent">made effortless.</span>
              </h2>

              <motion.ol
                className="revamp-hiw-steps"
                variants={listMotion}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
              >
                <motion.li className="revamp-hiw-step" variants={itemMotion}>
                  <div className="revamp-hiw-bullet" aria-hidden="true">
                    01
                  </div>
                  <div className="revamp-hiw-step-copy">
                    <div className="revamp-hiw-step-title">Post Your Requirement</div>
                    <div className="revamp-hiw-step-desc">
                      Share your city, budget, style, and timeline - in under 60 seconds.
                    </div>
                  </div>
                </motion.li>

                <motion.li className="revamp-hiw-step" variants={itemMotion}>
                  <div className="revamp-hiw-bullet" aria-hidden="true">
                    02
                  </div>
                  <div className="revamp-hiw-step-copy">
                    <div className="revamp-hiw-step-title">Browse Portfolios &amp; Reviews</div>
                    <div className="revamp-hiw-step-desc">
                      See their past work, read real reviews, and understand how they work -
                      <br />
                      before reaching out.
                    </div>
                  </div>
                </motion.li>

                <motion.li className="revamp-hiw-step" variants={itemMotion}>
                  <div className="revamp-hiw-bullet" aria-hidden="true">
                    03
                  </div>
                  <div className="revamp-hiw-step-copy">
                    <div className="revamp-hiw-step-title">Connect &amp; Build</div>
                    <div className="revamp-hiw-step-desc">
                      Send inquiry via HYNT, WhatsApp, or call &amp; Track your project, products and
                      <br />
                      progress in one place.
                    </div>
                  </div>
                </motion.li>
              </motion.ol>
            </div>
          </div>
        </div>
      </section>
    </section>
  );
}

export default RevampHeroFollow;
